import {isNotNil} from 'ramda';

import {ROWS_PER_PAGE, UserListLinksResponseBody, hasMoreUserListPages} from '@dms/api/core';

const MAX_LIST_PAGES_WITHOUT_TOTAL_COUNT = 1000;

/** Read every page only after the user explicitly requests an action on the whole list. */
export async function collectUserListVehicleIds<T>(
  fetchPage: (offset: number) => Promise<{data: T[]; links: UserListLinksResponseBody}>,
  getEligibleId: (vehicle: T) => string | undefined,
  assertContext: () => void = () => {}
) {
  const vehicles: T[] = [];
  let offset = 0;
  let hasMore = true;
  let pageCount = 0;
  let maxPages = MAX_LIST_PAGES_WITHOUT_TOTAL_COUNT;
  while (hasMore) {
    assertContext();
    const page = await fetchPage(offset);
    assertContext();
    vehicles.push(...page.data);
    pageCount += 1;
    if (isNotNil(page.links.totalCount)) {
      maxPages = Math.ceil(page.links.totalCount / ROWS_PER_PAGE) + 1;
    }
    hasMore = hasMoreUserListPages(page);
    if (hasMore && pageCount >= maxPages) {
      throw new Error('The user list returned more pages than its total count.');
    }
    offset += ROWS_PER_PAGE;
  }
  // Evaluate live eligibility only after every page has arrived, immediately before submission.
  assertContext();
  const ids = new Set<string>();
  for (const vehicle of vehicles) {
    const id = getEligibleId(vehicle);
    if (isNotNil(id)) {
      ids.add(id);
    }
  }
  return [...ids];
}
